import React, { useEffect, useRef } from 'react';
import ArticleCard from './ArticleCard';

// `getCardLabel(post)` optionally labels each card (series pages: "Part N").
function ArticlesGrid({ posts, getCardLabel }) {
    const gridRef = useRef(null);

    // Staggered card reveal on scroll — port of the live theme's main.js.
    useEffect(() => {
        const grid = gridRef.current;
        if (!grid || !('IntersectionObserver' in window)) {
            return undefined;
        }

        const cards = grid.querySelectorAll('.article-card');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                    entry.target.dataset.dsRevealed = '1';
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05 });

        cards.forEach((card, i) => {
            if (card.dataset.dsRevealed) {
                return;
            }
            card.style.opacity = '0';
            card.style.transform = 'translateY(8px)';
            card.style.transition = `opacity 0.35s ease ${i * 0.04}s, transform 0.35s ease ${i * 0.04}s`;
            observer.observe(card);
        });

        return () => observer.disconnect();
    }, [posts]);

    return (
        <div className="articles-grid" role="list" ref={gridRef}>
            {posts.map((post) => (
                <ArticleCard
                    key={post._id}
                    post={post}
                    label={getCardLabel ? getCardLabel(post) : undefined}
                />
            ))}
        </div>
    );
}

export default ArticlesGrid;
